import { render } from "./InsightTrigger.vue?vue&type=template&id=5962e8d8&scoped=true"
import script from "./InsightTrigger.vue?vue&type=script&lang=ts"
export * from "./InsightTrigger.vue?vue&type=script&lang=ts"

import "./InsightTrigger.vue?vue&type=style&index=0&id=5962e8d8&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-5962e8d8"

export default script